import { Link } from 'react-router-dom';
import { getUnitByName } from '../../shared/unitInfo';

const NUKE_CATEGORIES = [
    {
        key: 'arts',
        title: 'Arts Nukers',
        blurb: 'Fast, hard-hitting Arts',
    },
    {
        key: 'equip',
        title: 'Equip Nukers',
        blurb: 'High DMG passives with slots to hit hard',
    },
    {
        key: 'support',
        title: 'Nuke Supports',
        blurb: 'Buffs, debuffs, wave clear, burst Arts',
    },
];

const NUKE_TIERS = [
    {
        id: 'apex',
        label: 'Apex',
        units: {
            arts: [
                { name: 'Saito Hajime', thumb: '/db/Units/Thumbnail/unit_thumbnail_108137512.webp' },
                { name: 'Hero Saitama', thumb: '/db/Units/Thumbnail/unit_thumbnail_108157412.webp' },
                { name: 'Okarun', thumb: '/db/Units/Thumbnail/unit_thumbnail_108247312.webp' },
            ],
            equip: [
                { name: 'Hero Saitama', thumb: '/db/Units/Thumbnail/unit_thumbnail_108157412.webp' },
            ],
            support: [
                { name: 'Momon', thumb: '/db/Units/Thumbnail/unit_thumbnail_107907512.webp' },
                { name: 'Summer Luvia & Rin', thumb: '/db/Units/Thumbnail/unit_thumbnail_108017312.webp' },
                { name: 'Draken', thumb: '/db/Units/Thumbnail/unit_thumbnail_107636412.webp' },
            ],
        },
    },
    {
        id: 'strong',
        label: 'Strong',
        units: {
            arts: [
                { name: 'Saitama', thumb: '/db/Units/Thumbnail/unit_thumbnail_107076412.webp' },
                { name: 'Sunraku', thumb: '/db/Units/Thumbnail/unit_thumbnail_107867112.webp' },
                { name: 'Ultimate Paladin Roy', thumb: '/db/Units/Thumbnail/unit_thumbnail_103827212.webp' },
            ],
            equip: [
                { name: 'Delta', thumb: '/db/Units/Thumbnail/unit_thumbnail_108067112.webp' },
                { name: 'Cometstreak Valerie', thumb: '/db/Units/Thumbnail/unit_thumbnail_103897212.webp' },
                { name: 'Draken', thumb: '/db/Units/Thumbnail/unit_thumbnail_107636412.webp' },
                { name: 'Duke', thumb: '/db/Units/Thumbnail/unit_thumbnail_102526512.webp' },
            ],
            support: [
                { name: 'Genos', thumb: '/db/Units/Thumbnail/unit_thumbnail_107086512.webp' },
                { name: 'Summer Miyu', thumb: '/db/Units/Thumbnail/unit_thumbnail_107987112.webp' },
                { name: 'Okarun', thumb: '/db/Units/Thumbnail/unit_thumbnail_108247312.webp' },
                { name: 'Beta', thumb: '/db/Units/Thumbnail/unit_thumbnail_108057212.webp' },
            ],
        },
    },
    {
        id: 'average',
        label: 'Average',
        units: {
            arts: [
                { name: 'Makoto Shishio', thumb: '/db/Units/Thumbnail/unit_thumbnail_108147112.webp' },
                { name: 'Shalltear', thumb: '/db/Units/Thumbnail/unit_thumbnail_107717412.webp' },
                { name: 'Demon Lord Rimuru', thumb: '/db/Units/Thumbnail/unit_thumbnail_107837512.webp' },
                { name: 'Stark', thumb: '/db/Units/Thumbnail/unit_thumbnail_108227112.webp' },
                { name: 'Summer Bazett', thumb: '/db/Units/Thumbnail/unit_thumbnail_108007212.webp' },
            ],
            equip: [
                { name: 'Momon', thumb: '/db/Units/Thumbnail/unit_thumbnail_107907512.webp' },
                { name: 'Mikey', thumb: '/db/Units/Thumbnail/unit_thumbnail_107626512.webp' },
                { name: 'Genos', thumb: '/db/Units/Thumbnail/unit_thumbnail_107086512.webp' },
                { name: 'Erza', thumb: '/db/Units/Thumbnail/unit_thumbnail_107586412.webp' },
            ],
            support: [
                { name: 'New Years Milim', thumb: '/db/Units/Thumbnail/unit_thumbnail_107436412.webp' },
                { name: 'Jay', thumb: '/db/Units/Thumbnail/unit_thumbnail_103707212.webp' },
                { name: 'Gray Fullbuster', thumb: '/db/Units/Thumbnail/unit_thumbnail_107576212.webp' },
                { name: 'Sublime Supernova Liza', thumb: '/db/Units/Thumbnail/unit_thumbnail_103647412.webp' },
                { name: 'Yuzuriha', thumb: '/db/Units/Thumbnail/unit_thumbnail_107817512.webp' },
                { name: 'War Hero Fen', thumb: '/db/Units/Thumbnail/unit_thumbnail_103617312.webp' },
                { name: 'Frieren', thumb: '/db/Units/Thumbnail/unit_thumbnail_108207412.webp' },
                { name: 'Takemichi', thumb: '/db/Units/Thumbnail/unit_thumbnail_107616111.webp' },
            ],
        },
    },
    {
        id: 'niche',
        label: 'Niche / Bad',
        units: {
            arts: [
                { name: 'War Hero Fen', thumb: '/db/Units/Thumbnail/unit_thumbnail_103617312.webp' },
                { name: 'Simon', thumb: '/db/Units/Thumbnail/unit_thumbnail_103306512.webp' },
                { name: 'Santa Shion', thumb: '/db/Units/Thumbnail/unit_thumbnail_107416512.webp' },
                { name: 'Ragsherum', thumb: '/db/Units/Thumbnail/unit_thumbnail_101086511.webp' },
                { name: 'Duran', thumb: '/db/Units/Thumbnail/unit_thumbnail_101206412.webp' },
            ],
            equip: [],
            support: [
                { name: 'Chloe (GS)', thumb: '/db/Units/Thumbnail/unit_thumbnail_103056511.webp' },
                { name: 'Forte', thumb: '/db/Units/Thumbnail/unit_thumbnail_103106512.webp' },
                { name: 'Fen (Dark)', thumb: '/db/Units/Thumbnail/unit_thumbnail_102756512.webp' },
                { name: 'Melia (Dark)', thumb: '/db/Units/Thumbnail/unit_thumbnail_101076511.webp' },
                { name: 'Melia (Water)', thumb: '/db/Units/Thumbnail/unit_thumbnail_102536212.webp' },
            ],
        },
    },
];

function resolveNukeUnit(entry) {
    const unit = getUnitByName(entry.name);
    const thumb = unit?.image?.thumbsuper
        || unit?.image?.thumbawk
        || entry.thumb
        || '';

    return {
        name: unit?.name || entry.name,
        thumb,
    };
}

function NukeUnit({ unit }) {
    return (
        <div className="gs-tierlist-unit">
            <Link to={`/units/${unit.name}`}>
                <img src={unit.thumb} alt={unit.name} loading="lazy" />
                <span className="gs-thumb-name">{unit.name}</span>
            </Link>
        </div>
    );
}

function NukeCategoryColumn({ category, units }) {
    const resolved = units.map(resolveNukeUnit);

    return (
        <div className={`gs-nuke-col gs-nuke-col--${category.key}`}>
            <div className="gs-nuke-col__head">
                <h3 className="gs-nuke-col__title">{category.title}</h3>
                <p className="gs-nuke-col__blurb">{category.blurb}</p>
            </div>
            {resolved.length > 0 ? (
                <div className="gs-tierlist-grid gs-nuke-col__grid">
                    {resolved.map((unit) => (
                        <NukeUnit key={`${category.key}-${unit.name}`} unit={unit} />
                    ))}
                </div>
            ) : (
                <p className="gs-nuke-col__empty">None listed</p>
            )}
        </div>
    );
}

export const CreateNukeTable = () => {
    return (
        <div className="gs-nuke">
            <div className="gs-nuke__tiers">
                {NUKE_TIERS.map((tier) => (
                    <section
                        key={tier.id}
                        className={`gs-nuke-tier gs-nuke-tier--${tier.id}`}
                        aria-labelledby={`nuke-tier-${tier.id}`}
                    >
                        <h2 id={`nuke-tier-${tier.id}`} className="gs-nuke-tier__title">
                            {tier.label}
                        </h2>
                        <div className="gs-nuke-tier__cols">
                            {NUKE_CATEGORIES.map((category) => (
                                <NukeCategoryColumn
                                    key={category.key}
                                    category={category}
                                    units={tier.units[category.key]}
                                />
                            ))}
                        </div>
                    </section>
                ))}
            </div>
        </div>
    );
};
